export default {
      id: "dateDesc-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#dateDesc",
      toString: function () {
        return this.url;
      }
    }